export default __webpack_public_path__ + "static/media/hbs-icon.335963e8.svg";